import PropTypes from 'prop-types'
import React from 'react'
import classes from '../Content.module.scss'

export class ContentIconGroup extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
  }

  render () {
    let {
      className,

      children,

      ...restProps
    } = this.props

    let compClassName = classes.iconGroup
    if (className) compClassName += ' ' + className

    return (
      <div
        {...restProps}
        className={compClassName}
      >
        {children}
      </div>
    )
  }
}

export default ContentIconGroup
